import { headers, formateData } from "./index";
import {applicationName} from "../utils";
//图集列表
export const getInterviewId = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/interview/getInterviewStoryInfos";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};